import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'submissionDate';
export const apiKey = 'CreatedDateTime';
export const type = TYPE_DATE_COMPARISON;

export const submissionDate = {
  id,
  apiKey,
  type,
};
